import { createSlice } from "@reduxjs/toolkit";

const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
};

const setFailure = (state) => {
  state.isLoading = false;
};

const assignedtasksSlice = createSlice({
  name: "Assignedtasks",
  initialState: {
    isLoading: false,
    tasksList: [],
  },
  reducers: {
    // login
    getAssignedtasksRequest: (state) => setLoading(state, true),
    getAssignedtasksSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "tasksList"),
    getAssignedtasksFailure: (state) => setLoading(state, false),
  },
});

export const { getAssignedtasksRequest, getAssignedtasksSuccess, getAssignedtasksFailure } =
assignedtasksSlice.actions;

export const assignedtasksReducerSlice = assignedtasksSlice.reducer;
